import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import ImageIcon from "@mui/icons-material/Image";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import "./FileCard.css";

const FileCard = ({ fileName, documentId, onRemove }) => {
    const getFileIcon = (fileName) => {
        const extension = fileName.split(".").pop().toLowerCase();
        switch (extension) {
            case "jpg":
            case "jpeg":
            case "png":
            case "gif":
                return <ImageIcon className="file-icon" />;
            case "pdf":
                return <PictureAsPdfIcon className="file-icon" />;
            case "doc":
            case "docx":
            case "txt":
                return <DescriptionIcon className="file-icon" />;
            case "mp4":
            case "mov":
            case "avi":
                return <VideoLibraryIcon className="file-icon" />;
            default:
                return <InsertDriveFileIcon className="file-icon" />;
        }
    };

    return (
        <div
            className="file-card"
            title={`Document ID: ${documentId || "N/A"}`}
        >
            <div className="file-card-header">
                <div className="file-icon-container">{getFileIcon(fileName)}</div>
                <span className="file-name" title={fileName}>
                    {fileName.length > 15 ? `${fileName.substring(0, 12)}...` : fileName}
                </span>
                <button
                    className="remove-button"
                    onClick={onRemove}
                    aria-label="Remove file"
                >
                    <CloseIcon fontSize="small" />
                </button>
            </div>
        </div>
    );
};

export default FileCard;
